<template>
  <div class="tab-content">
    <el-tabs activeName="first">
      <el-tab-pane :label="$t('project_tab_files_first')" name="first">
        <el-card>
          <div v-if="showUploadPercentage" class="progress">
            <el-progress :percentage="uploadPercentage"></el-progress>
          </div>
          <form class="loading"
                :class="{
                  'is-dragover': dragover
                }"
                @drop.prevent="onDrop"
                @dragover.prevent="onDragover"
                @dragleave.prevent="dragover = false">
            <label for="file" class="loading__label">
              <i class="el-icon-upload"></i>
              {{$t('project_tab_files_first_title')}}
            </label>
            <input :disabled="!projectPermission.addTaskFiles" ref='file' v-show="false" @change="handleFile" id="file" name="myFile" type="file">
          </form>
          <div style="display: flex; align-items: center; cursor: pointer;">
            <img src="@/assets/img/icons/microsoft-office.png" height="28" alt="Office" @click="createNewFileOpenModal(selectedRow)">
            <el-button @click="createNewFileOpenModal(selectedRow)" type="primary" size="mini" plain>{{$t('general_createNewFile')}}</el-button>
          </div>
          <el-table
                  :data="newFileList"
                  style="width: 100%; margin-top:10px;"
                  :empty-text="$t('general_noData')"
                  @cell-click="cellClick"
                  :cell-class-name="cellClassName"
                  :row-class-name="tableRowClassName"
                  row-key="id"
                  size="mini"
                  border>
            <el-table-column width="50">

            </el-table-column>
            <el-table-column
                    :label="$t('project_tab_files_first_fileNo')"
                    width="60">
              <template slot-scope="scope">
                <div class="file__item_id" v-if="scope.row.fileNo">{{scope.row.fileNo}} </div>
              </template>
            </el-table-column>
            <el-table-column
                    :label="$t('project_tab_files_first_ver')"
                    width="50">
              <template slot-scope="scope">
                <div class="file__item_id" v-if="scope.row.rev">{{scope.row.rev}} </div>
              </template>
            </el-table-column>
            <el-table-column
                    column-key="banner"
                    width="50">
              <template slot-scope="scope">
                <fileImg style="width:30px;" :url="scope.row.url.split('.').pop().toUpperCase()"/>
              </template>
            </el-table-column>
            <el-table-column
                    :label="$t('project_tab_files_first_name')">
              <template slot-scope="scope">
                {{scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('project_tab_files_first_size')">
              <template slot-scope="scope">
                {{scope.row.size }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('project_tab_files_first_date')">
              <template slot-scope="scope">
                {{scope.row.date }}
              </template>
            </el-table-column>
            <el-table-column
                    width="150"
                    :label="$t('project_tab_files_first_user')">
              <template slot-scope="scope">
                {{scope.row.user }}
              </template>
            </el-table-column>
            <el-table-column
                    width="100">
              <template slot-scope="scope">
                <!--{{scope.row.isEditNow}}-->
                <el-dropdown>
                    <span class="el-dropdown-link">
                      {{$t('project_tab_files_first_action')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item
                            @click.native="viewFile(scope.row.url, scope.row, 27, true)"
                            icon="el-icon-view"
                            :disabled="!projectPermission.viewTaskFiles || scope.row.isEditNow">
                      {{$t('project_tab_files_first_view')}}
                    </el-dropdown-item>
                    <el-dropdown-item
                            v-if="ifCanEdit(scope.row.url)"
                            @click.native="editFile(scope.row.url, scope.row, 'projectTask', selectedRow.projectId, selectedRow.id)"
                            icon="el-icon-edit-outline"
                            :disabled="!projectPermission.editTaskFile || scope.row.isEditNow || !!scope.row.parentId">
                      {{$t('project_tab_files_edit_file')}}
                    </el-dropdown-item>
                    <el-dropdown-item
                            @click.native="downloadFiles(scope.row.url, scope.row.name, scope.row)"
                            class="download-btn" icon="el-icon-upload"
                            :disabled="!projectPermission.downloadTaskFiles || scope.row.isEditNow">
                      {{$t('project_tab_files_first_download')}}
                    </el-dropdown-item>
                    <el-dropdown-item
                            :disabled="!projectPermission.uploadTaskRevisionFiles || scope.row.isEditNow">
                      <form>
                        <label>
                          <div v-show="!scope.row.parentId" class="btn">
                            <i class="el-icon-upload2"></i>{{$t('project_tab_files_first_uploadRevision')}}
                          </div>
                          <input ref='fileUpg' v-show="false" @change="upgradeFile($event, scope.row.id)" name="myFile" type="file">
                        </label>
                      </form>
                    </el-dropdown-item>
                    <el-dropdown-item
                            :disabled="!projectPermission.deleteTaskFiles || scope.row.isEditNow"
                            @click.native="deleteFile(scope.row)"
                            icon="el-icon-delete">
                      {{$t('project_tab_files_first_delete')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
              <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
          </div>
          <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
              <img :src="fileUrl" :key="fileUrl" />
            </div>
          </div>
          <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
              <span>x</span>
            </div>
              <Media
                :kind="'video'"
                :controls="true"
                :src="fileUrl"
              >
              </Media>
          </div>
          <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
              <span>x</span>
            </div>
              <Media
                :kind="'audio'"
                :controls="true"
                :src="fileUrl"
              >
              </Media>
          </div>

          <!--View File Modal Start-->
          <el-dialog :title="$t('viewTaskFiles')" :visible.sync="docsDialog" fullscreen @close="closeDocViewModal" custom-class="docs-dialog">
            <div style="height: calc(100vh - 90px);">
              <div id="placeholder-1"></div>
            </div>
          </el-dialog>
          <!--View File Modal End-->

          <el-dialog
                  :title="$t('project_tab_files_edit_file')"
                  :visible.sync="docsEditDialog"
                  fullscreen
                  @close="closeDocEditCreatedFileModal"
                  custom-class="docs-dialog"
                  :show-close="docsEditDialog">
            <div style="height: calc(100vh - 90px);">
              <div id="placeholder-2"></div>
            </div>
          </el-dialog>

        </el-card>
      </el-tab-pane>
    </el-tabs>
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div>-->
<!--        <div v-if="bookmarkList.files" @click="changeBookMark(bookmarkList.files, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.files, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->
    <create-new-file-modal ref="createNewFileModal" @openCreatedFile="openCreatedFile"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Media from '@dongido/vue-viaudio'
import fileImg from '../fileImg'
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
import { viewEditFileMixin } from '../../mixins/viewEditFileMixin'
import CreateNewFileModal from "../createNewFileModal/index";

export default {
  components: {
    CreateNewFileModal,
    SweetModal,
    fileImg,
    Media,
  },
  props: ['projectPermission', 'bookmarkList', 'selectedRow'],
  mixins: [viewEditFileMixin],
  data() {
    return {
      activeStar: 'el-icon-star-on',
      notActiveStar: 'el-icon-star-off',
      showUploadPercentage: false,
      uploadPercentage: 0,
      dragover: false,
      fileSavingNotification: null,
      ifNeedToConvertMov: false
    }
  },
  computed: {
    ...mapGetters([
      'getNotificationDuration'
    ]),
    user(){
      return this.$store.state.user
    },
    taskFileList() {
      return this.$store.state.taskFiles
    },
    newFileList(){
      return this.$store.state.taskFiles
    }
  },
  created(){
    let docApiScript = document.createElement('script');
    docApiScript.setAttribute('src', 'https://office2.totalflow.io/web-apps/apps/api/documents/api.js');
    document.head.appendChild(docApiScript);
  },
  methods: {
    downloadFiles(url, name, row) {

      // // document.location.href = `${url + '/' + name}?mode=attachment`;
      // let restOfTheUrl = url.split('https://storage.totalflow.io/')[1] || ''
      // // alert(restOfTheUrl)
      // let newUrl = `https://storage.totalflow.io/d.php?${restOfTheUrl + '/' + encodeURIComponent(name)}`
      // document.location.href = newUrl
      document.location.href = row.urlDownload

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/history/create`, {
          companyId: this.$route.query.companyId,
          entityTypeId: 27,
          entityId: this.$route.query.projectId,
          taskId: this.$route.query.taskId,
          logAction: 'download',
          logType: 'File',
          fileParams: {
            id: row.fileServiceId,
            pathToDownload: row.url,
            originalName: row.name,
            createdDate: row.date,
            allFileId: row.id,
          }
        })
        .then(response => {
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        })
    },
    testing(){
      console.log('array', this.newFileList);
      console.log('this.$store.state.taskFiles', this.$store.state.taskFiles)
    },
    openCreatedFile(data) {
      this.editCreatedFile(data.pathToDownload, data, 'projectTask', this.selectedRow.projectId, this.selectedRow.id)
    },
    openWarningModalAll(row) {
      this.$confirm(this.$t('project_tab_files_first_delete_text'), this.$t('project_tab_files_first_delete_title'), {
        distinguishCancelAndClose: true,
        type: 'info',
        confirmButtonText: this.$t('project_tab_files_first_delete_current'),
        cancelButtonText: this.$t('project_tab_files_first_delete_all')
      })
          .then(() => {
            this.deleteFileCurrent(row)
          })
          .catch(action => {
            if (action === 'cancel') {
              this.deleteFileAll(row)
            }
          });
    },
    deleteFileCurrent(row) {
      this.$confirm(this.$t('file_thisWillPermanentlyDeleteTheFileContinue'), this.$t('notification_title_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${row.id}&entityId=${this.selectedRow.id}&entityTypeId=27&deleteChild=false&taskId=${this.$route.query.taskId}&historyEntityId=${this.$route.query.projectId}`)
            .then(response => {
              this.$store.dispatch('getTaskFiles', this.selectedRow.id);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    deleteFileAll(row) {
      this.$confirm(this.$t('file_thisWillPermanentlyDeleteTheFilesContinue'), this.$t('notification_title_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${row.id}&entityId=${this.selectedRow.id}&entityTypeId=27&deleteChild=true&taskId=${this.$route.query.taskId}&historyEntityId=${this.$route.query.projectId}`)
            .then(response => {
              this.$store.dispatch('getTaskFiles', this.selectedRow.id);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    async onDrop(e) {
      // check if mov file uploaded
      const file = e.dataTransfer.files[0];
      const ifMov = this.movChecker(e.dataTransfer.files[0]);
      if (ifMov === 'cancel') return;
      this.ifNeedToConvertMov = false;
      if (ifMov) {
        this.ifNeedToConvertMov = await this.askBeforeMovUploaded();
        if (this.ifNeedToConvertMov === 'closeModal') {
          this.resetInputs();
          return
        }
      }

      const formData = new FormData();
      formData.append('file', file);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      //check equals start
      const fileName = file.name.trim();

      let index = null;
      // Find coincidence of names in table function
      const even = function (element) {
        if (element.name.trim() === fileName){
          index = element.id;
          return element.name.trim() === fileName;
        }
      };

      // Find coincidence
      if (this.taskFileList.some(even)) {
        // change e for function friendly
        // e.target.files = e.dataTransfer.files;
        this.ifFileExist(file, index);
        return
      }
      //check equals end

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      // formData.append('convert', false);
      formData.append('entityId', this.selectedRow.id);
      formData.append('entityTypeId', 27);
      formData.append('oldParentId', null);
      formData.append('taskId', this.$route.query.taskId);
      formData.append('historyEntityId', this.$route.query.projectId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
              .then(response => {
                console.log('---projectTaskFiles/create', response.data);
                this.notification("Success", "File upload", "success");
                this.$store.dispatch('getTaskFiles', this.selectedRow.id);
                this.resetInputs();
                loader.hide();
                this.showUploadPercentage = false;
                this.uploadPercentage = 0;
                this.dragover = false
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
                this.showUploadPercentage = false;
                this.uploadPercentage = 0;
                this.dragover = false;
              });
    },
    askBeforeMovUploaded(){
      return new Promise (resolve => {
        this.$confirm(this.$t('modal_convertMovToMP4'), this.$t('general_info'), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t('general_convert'),
          cancelButtonText: this.$t('modal_convertMovToMP4_no'),
          type: 'info'
        }).then(() => {
          resolve(true)
        }).catch(action => {
          if (action === 'cancel') return resolve(false);
          return resolve('closeModal')
        });
      });
    },
    onDragover() {
        this.dragover = true;
    },
    ifFileExist(file, index){
      return new Promise ((resolve) => {
        this.$confirm(`The file with Similar name is already present, new version will be added automatically`,{
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'Upload',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.upgradeExistedFile(file, index);
          resolve(true)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel'
          });
        });
        this.resetInputs();
        this.dragover = false
      })
    },
    async upgradeExistedFile(file, index) {
      const formData = new FormData();
      formData.append('file', file);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      // formData.append('convert', false);
      formData.append('entityId', this.selectedRow.id);
      formData.append('entityTypeId', 27);
      formData.append('oldParentId', index || null);
      formData.append('taskId', this.$route.query.taskId);
      formData.append('historyEntityId', this.$route.query.projectId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
              .then(response => {
                console.log('---projectTaskFiles/create', response.data);
                this.notification("Success", "New File Version Uploaded", "success");
                this.$store.dispatch('getTaskFiles', this.selectedRow.id);
                this.resetInputs();
                loader.hide();
                this.showUploadPercentage = false;
                this.uploadPercentage = 0
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide();
                this.showUploadPercentage = false;
                this.uploadPercentage = 0
              });
    },
    deleteFile(row) {
      if (row.children.length) {
        this.openWarningModalAll(row)
      } else {
        this.deleteFileCurrent(row)
      }
    },
    closeMod() {
      this.viewerType = 0;
    },
    show() {
      const viewer = this.$el.querySelector('.images').$viewer;
      viewer.show()
    },
    async handleFile(e) {
      // check if mov file uploaded
      const file = e.target.files[0];
      const ifMov = this.movChecker(e.target.files[0]);
      if (ifMov === 'cancel') return;
      this.ifNeedToConvertMov = false;
      if (ifMov) {
        this.ifNeedToConvertMov = await this.askBeforeMovUploaded();
        if (this.ifNeedToConvertMov === 'closeModal') {
          this.resetInputs();
          return
        }
      }

      const formData = new FormData();
      formData.append('file', file);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      //check equals start
      const fileName = file.name.trim();

      let index = null;
      // Find coincidence of names in table function
      const even = function (element) {
        if (element.name.trim() === fileName){
          index = element.id;
          return element.name.trim() === fileName;
        }
      };

      // Find coincidence
      if (this.taskFileList.some(even)) {
        // change e for function friendly
        this.ifFileExist(file, index);
        return
      }
      //check equals end

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      formData.append('entityId', this.selectedRow.id);
      formData.append('entityTypeId', 27);
      formData.append('oldParentId', null);
      formData.append('taskId', this.$route.query.taskId);
      formData.append('historyEntityId', this.$route.query.projectId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
              console.log('---projectTaskFiles/create', response.data);
              this.notification("Success", "File upload", "success");
              this.$store.dispatch('getTaskFiles', this.selectedRow.id);
              this.resetInputs();
              loader.hide();
              this.showUploadPercentage = false;
              this.uploadPercentage = 0
          })
          .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              this.showUploadPercentage = false;
              this.uploadPercentage = 0
          });
    },
    createNewFileOpenModal(selectedRow){
      this.$refs.createNewFileModal.openModal(selectedRow, 'projectTask')
    },
    closeDocViewModal(){
      this.docEditor.destroyEditor();
      this.type = '';
      this.fileUrl = '';
      this.viewerType = 0;
      this.docsDialog = false;
      this.docEditor = {}
    },
    closeDocEditCreatedFileModal(){
      // let loader = this.$loading.show();
      this.docEditor.destroyEditor();
      this.type = '';
      this.fileUrl = '';
      this.viewerType = 0;
      this.docsEditDialog = false;
      this.docEditor = {};
      this.$store.dispatch('hideFileNotification', 0);
      this.fileSavingNotification = this.$notify({
        title: this.$t('general_info'),
        message: this.$t('general_fileIsSavingItWillTakeSomeTime'),
        type: 'info',
        duration: 12000
      });
      // this.$store.dispatch('getTaskFiles', this.selectedRow.id);
      // setTimeout(() => {
      //   loader.hide();
      //   this.notification(this.$t('general_success'), this.$t('general_fileSuccessfullySaved'), "success");
      //   this.$store.dispatch('getTaskFiles', this.selectedRow.id);
      // }, 11000)
    },
    async upgradeFile(e, index) {
      // check if mov file uploaded
      const ifMov = this.movChecker(e.target.files[0]);
      if (ifMov === 'cancel') return;
      this.ifNeedToConvertMov = false;
      if (ifMov) {
        this.ifNeedToConvertMov = await this.askBeforeMovUploaded();
        if (this.ifNeedToConvertMov === 'closeModal') {
          this.resetInputs();
          return
        }
      }

      const formData = new FormData();
      formData.append('file', e.target.files[0]);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      formData.append('entityId', this.selectedRow.id);
      formData.append('entityTypeId', '27');
      formData.append('oldParentId', index);
      formData.append('taskId', this.$route.query.taskId);
      formData.append('historyEntityId', this.$route.query.projectId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
              console.log('---projectTaskFiles/create', response.data);
              this.notification("Success", "New File Version Uploaded", "success");
              this.$store.dispatch('getTaskFiles', this.selectedRow.id);
              this.resetInputs();
              loader.hide();
              this.showUploadPercentage = false;
              this.uploadPercentage = 0
          })
          .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              this.showUploadPercentage = false;
              this.uploadPercentage = 0
          });
    },
    cellClick(row, column, event){
      if(column.label === 'Name' && this.projectPermission.viewTaskFile && !row.isEditNow
          || column.columnKey === 'banner' && this.projectPermission.viewTaskFile && !row.isEditNow){
        this.viewFile(row.url, row, 27, true)
      }
    },
    cellClassName({row, column, rowIndex, columnIndex}){
      if(columnIndex === 3 || columnIndex === 4){
        return 'file-name'
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    changeBookMark(state, companyid, projectId, taskId){
      let data = this.bookmarkList;
      data.files = !this.bookmarkList.files;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
              .then(response => {
                if (this.bookmarkList.files) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
    },
    tableRowClassName({row, rowIndex}) {
      if (row.isEditNow) return 'disabled-row';
      return '';
    },
    resetInputs(){
      if (this.$refs.fileUpg) this.$refs.fileUpg.value = null;
      if (this.$refs.file) this.$refs.file.value = null;
    }
  },
  watch:{
    getNotificationDuration(val) {
      if (this.fileSavingNotification && val === 500) {
        this.fileSavingNotification.duration = 500;
        this.fileSavingNotification = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  margin-bottom: 15px;
}
.mod {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,0.8);
  z-index: 99999;
  &__close {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    cursor: pointer;
    height: 80px;
    overflow: hidden;
    position: absolute;
    right: -40px;
    top: -40px;
    -webkit-transition: background-color 0.15s;
    transition: background-color 0.15s;
    width: 80px;
    span {
      color: #fff;
      bottom: 15px;
      left: 15px;
      position: absolute;
      z-index: 99999;
    }
  }
  video {
    height: 80%;
  }
}
.loading {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  // padding-top:35px;
  &__label {
    width: 100%;
    height: 180px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    z-index: 0;

    &:hover {
      border-color: #409EFF;
    }
    .el-icon-upload {
      display: block;
      font-size: 67px;
      color: #C0C4CC;
      margin: 40px 0 16px;
      line-height: 50px;
    }
    span {
      color: #409EFF;
    }
  }
  &.is-dragover{
    border: 1px dashed #409EFF;
    border-radius: 6px;
    .loading__label{
      background-color:rgba(32,159,255,.06);
    }
  }
}

.tree {
  width: 100%;
  font-size: 12px;
  .file {
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
    }
    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;

      &_link {
        display: flex;
        justify-content: flex-end;
        width: 153px;

        .btn {
          color: #409EFF;
          background: #ecf5ff;
          border: 1px solid #b3d8ff;
          margin-left: 10px;
          padding: 7px 15px;
          font-size: 12px;
          border-radius: 3px;
          cursor: pointer;
          &:hover {
            background: #409EFF;
            border-color: #409EFF;
            color: #FFF;
          }
        }
      }

      &_id {
        width: 20px;
        text-align: center;
      }
      &_name {
        width: 250px;
        cursor: pointer;
      }
      &_size {
        white-space: nowrap;
        text-align: center;
      }
      &_date {
        width: 100px;
        text-align: center;
      }
      &_user {
        width: 120px;
        text-align: center;
      }
    }
  }
}

.padding-left {
  padding-left: 10px;
}
.font-weight {
  font-weight: 700;
}

.iframe{
  width:640px;
  height:700px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
/deep/.download-btn{
  a{
    color:#606266;
    &:hover{
      color:#66b1ff;
    }
  }
}
/deep/.file-name{
  &:hover{
    cursor:pointer;
    div {
      text-decoration: underline;
    }
  }
}
/deep/.docs-dialog{
    .el-dialog__body{
      padding:5px 0 0 0;
    }
  }
/deep/.el-table .disabled-row {
  background: #F5F7FA;
  cursor: no-drop;
}
</style>
